import { useEffect } from 'react';
import { useSettings } from '../settings/store.ts';
import { usePrefsStore } from './prefsStore.ts';

/**
 * Ctrl+Alt+B shows or hides the info bar and Ctrl+, opens or closes Ayarlar, from anywhere. `code` is used
 * because Alt changes `key` on macOS.
 */
export function useInfoBarShortcut() {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.metaKey || event.shiftKey) return;
      if (event.ctrlKey && event.altKey && event.code === 'KeyB') {
        event.preventDefault();
        const { prefs, update } = usePrefsStore.getState();
        update({ visible: !prefs.visible });
      } else if (event.ctrlKey && !event.altKey && event.code === 'Comma') {
        event.preventDefault();
        const { open, openSettings, close } = useSettings.getState();
        if (open) close();
        else openSettings();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
